import { HttpClient, HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileDownloaderUtils } from '../file-downloader.utils';

@Injectable({
    providedIn: 'root',
})
export class UnitPublicService {
    private httpClient: HttpClient;

    constructor(private handler: HttpBackend) {
        this.httpClient = new HttpClient(this.handler);
    }

    loadSvgForLocation(location: string) {
        return this.httpClient.get(
            `assets/images/svgs/${location}/buildingplan.svg`,
            {
                responseType: 'text',
            },
        );
    }

    getUnitsForLocation(locationId: string) {
        return this.httpClient.get(`/api/units/public/location/${locationId}`);
    }

    getSingleUnit(unitId: string, token?: string) {
        const params = token ? { token } : {};
        return this.httpClient.get(`/api/units/${unitId}`, { params });
    }

    getSingleLocation(locationId: string) {
        if (!locationId) return;
        return this.httpClient.get(`/api/storage-location/${locationId}`);
    }

    getStoredItems() {
        return this.httpClient.get('/api/stored-items');
    }

    getSubscriptionsForType(type: string) {
        return this.httpClient.get(`/api/unit-type/${type}`);
    }

    getLocations() {
        return this.httpClient.get('/api/storage-location');
    }

    getInsurancePackages() {
        return this.httpClient.get('/api/insurance');
    }

    getPublicDocuments(storageLocationId: string) {
        return this.httpClient.get(`/api/public-files/${storageLocationId}`);
    }

    getGlobalDocuments() {
        return this.httpClient.get(`/api/public-files/global`);
    }

    getFloorplan(id) {
        return this.httpClient.get(`/api/public-files/file/${id}`, {
            responseType: 'text',
        });
    }

    openPublicDocument(id) {
        return this.httpClient.get(`/api/public-files/file/${id}`, {
            responseType: 'blob',
        });
    }

    openDocument(doc) {
        this.openPublicDocument(doc._id).subscribe((_data: any) => {
            var newBlob = new Blob([_data], {
                type: FileDownloaderUtils.getMimeType(doc.name),
            });
            const data = window.URL.createObjectURL(newBlob);

            var link = document.createElement('a');
            link.href = data;
            link.target = '_blank';
            link.rel = 'noopener';
            link.download = doc.originalname;
            window.open(link.href);
        });
    }
}
